import { List as CXList, ListItem as CXListitem } from '@sanlamcx/react-ui-next-list';

type IList = typeof CXList;
export const List: IList = CXList;
export const ListItem = CXListitem;
